import type { Series } from './palette';
import { CHROME } from './palette';

/**
 * A series' marker: a circle, a square or a diamond, with a 2px ring of the
 * surface so two markers on the same point still read as two.
 */
export function Marker({ shape, x, y, color, r = 3.5, ring = true }: {
  shape: Series['marker'];
  x: number;
  y: number;
  color: string;
  r?: number;
  ring?: boolean;
}) {
  const stroke = ring ? { stroke: CHROME.surface, strokeWidth: 2 } : {};
  if (shape === 'square') {
    return <rect x={x - r} y={y - r} width={r * 2} height={r * 2} fill={color} {...stroke} />;
  }
  if (shape === 'diamond') {
    const d = r * 1.35;
    return <polygon points={`${x},${y - d} ${x + d},${y} ${x},${y + d} ${x - d},${y}`} fill={color} {...stroke} />;
  }
  if (shape === 'triangle') {
    const d = r * 1.4;
    return <polygon points={`${x},${y - d} ${x + d},${y + d * 0.8} ${x - d},${y + d * 0.8}`} fill={color} {...stroke} />;
  }
  return <circle cx={x} cy={y} r={r} fill={color} {...stroke} />;
}

/** The same marker, as a legend swatch beside its label. */
export function Swatch({ shape, color, area }: { shape?: Series['marker']; color: string; area?: boolean }) {
  return (
    <svg aria-hidden width="14" height="14" viewBox="0 0 14 14" className="shrink-0">
      {area
        ? <rect x="1" y="3" width="12" height="9" rx="1.5" fill={color} opacity="0.6" />
        : <>
          <line x1="0" y1="7" x2="14" y2="7" stroke={color} strokeWidth="2" />
          <Marker shape={shape ?? 'circle'} x={7} y={7} color={color} r={3} ring={false} />
        </>}
    </svg>
  );
}
